import { render } from "./young_talent_AS.vue?vue&type=template&id=42dbc963&scoped=true"
import script from "./young_talent_AS.vue?vue&type=script&lang=js"
export * from "./young_talent_AS.vue?vue&type=script&lang=js"

import "./styles/shared_AS.css?vue&type=style&index=0&id=42dbc963&scoped=true&lang=css&external"
import "./styles/young_talent_AS.css?vue&type=style&index=1&id=42dbc963&scoped=true&lang=css&external"
import "./young_talent_AS.vue?vue&type=style&index=2&id=42dbc963&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dbc963"]])

export default __exports__